import React from "react";

import Cotizacion3 from "./Cotizacion3ResumenRenovacion";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { consultarPlacaFetch, fetchSetPoliticasDeducibles, limpiarDatosDescarga, limpiarDatosEnvio } from "../../../../redux/actions/aCotizacion";
import ErrorPage from "../../../../components/ErrorPage";
import { PermisosCotizadores } from "../../../../constants";
import { validarModuloRenovacion } from "../../redux/aRenovaciones";

//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";

class ContainerCotizacionRenovacion extends React.Component {

  getIdentifier(){
    // guardar el identificador del cotizador actual
    const queryParams = new URLSearchParams(this.props.location.search);
    // acceder al parametro de url
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    if (codigoProductoEspecial === null ||  (codigoProductoEspecial !='vehiculosKilometrosPaquete' && codigoProductoEspecial !='comparador' && codigoProductoEspecial !='externo' && codigoProductoEspecial !='KilometrosConsumidos' && codigoProductoEspecial !='pits')) {
      codigoProductoEspecial = '';
    }
    // return
    return codigoProductoEspecial;
  }

  getPaso(){

     // guardar el identificador del cotizador actual
     const queryParams = new URLSearchParams(this.props.location.search);
     // acceder al parametro de url
     let paso = queryParams.get("paso");

     return paso;

  }

  constructor(props) {
    super(props);
    this.state = {
      codigoProductoEspecial: this.getIdentifier(),
      paso: this.getPaso()
    };
  }


  componentDidMount() {
    this.props.limpiarDescargas();
    this.props.limpiarEnvio();
    const queryParams = new URLSearchParams(this.props.location.search);
    let codigoProductoEspecial = queryParams.get("codigoProductoEspecial");
    this.props.setPoliticasDeducibles(codigoProductoEspecial =='comparador' || codigoProductoEspecial =='pits' ? true : null);
  }

  render() {
    return (
      (this.state.codigoProductoEspecial !='' || this.state.paso=='datosfacturacion') ?
      <main className="cr-app bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            {
                 validarModuloRenovacion(this.props.datosUsuario.dataUsuario.usu_tipo_usuario) ?
                 <Cotizacion3 datosCotizacion={this.props.datosCotizacion} /> :
                   <ErrorPage mainText="No tienes permisos para acceder a esta funcionalidad" secondaryText="Por favor, contacta al administrador si crees que esto es un error" />
            }
        
          </div>
        </div>
      </main>
      :
      <ErrorPage mainText={PermisosCotizadores.msgSinProductoAuto } />
    );
  }
}

const mapStateToProps = state => ({
  datosCotizacion: state.datosCotizacion,
  datosUsuario: state.datosUsuarios,
});

const mapDispatchToProps = dispatch => {
  return {
    consultarPlaca: placa => dispatch(consultarPlacaFetch(placa)),
    limpiarDescargas: () => dispatch(limpiarDatosDescarga()),
    setPoliticasDeducibles: (esComparador) => dispatch(fetchSetPoliticasDeducibles(esComparador)),
    limpiarEnvio: () => dispatch(limpiarDatosEnvio()),
  };
};

export default
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionRenovacion)

